import React, { cloneElement } from 'react';
import { isElement, createEventHandler } from '@mantine/utils';
import { useHoverCardContext } from '../HoverCard.context.js';
import { HOVER_CARD_ERRORS } from '../HoverCard.errors.js';
import { Popover } from '../../Popover/Popover.js';

function HoverCardTarget({ children, refProp }) {
  if (!isElement(children)) {
    throw new Error(HOVER_CARD_ERRORS.children);
  }
  const ctx = useHoverCardContext();
  const onMouseEnter = createEventHandler(children.props.onMouseEnter, ctx.openDropdown);
  const onMouseLeave = createEventHandler(children.props.onMouseLeave, ctx.closeDropdown);
  return /* @__PURE__ */ React.createElement(Popover.Target, {
    refProp
  }, cloneElement(children, { onMouseEnter, onMouseLeave }));
}
HoverCardTarget.displayName = "@mantine/core/HoverCardTarget";

export { HoverCardTarget };
//# sourceMappingURL=HoverCardTarget.js.map
